export const INPUT_WIDTH = 250
